module.exports = __webpack_public_path__ + "static/media/logo.75b7a7f8.png";